import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Sends the httpOnly auth cookie with every request. Required for cross-origin
 * XHR/fetch to include credentials; harmless for same-origin (dev proxy) calls.
 */
export const credentialsInterceptor: HttpInterceptorFn = (req, next) =>
  next(req.clone({ withCredentials: true }));
